var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLibrary01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#5BA89F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_11555",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_11555)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.973 242.453V222.656H189.738C194.236 222.656 196.82 225.432 196.82 229.328C196.82 233.279 194.195 236 189.629 236H186.074V242.453H181.973ZM186.074 232.691H188.973C191.406 232.691 192.596 231.324 192.582 229.328C192.596 227.359 191.406 226.033 188.973 226.02H186.074V232.691ZM200.785 242.699C199.5 242.699 198.461 241.674 198.488 240.402C198.461 239.145 199.5 238.119 200.785 238.133C202.002 238.119 203.055 239.145 203.055 240.402C203.055 241.674 202.002 242.699 200.785 242.699ZM206.391 242.453V222.656H214.156C218.654 222.656 221.238 225.432 221.238 229.328C221.238 233.279 218.613 236 214.047 236H210.492V242.453H206.391ZM210.492 232.691H213.391C215.824 232.691 217.014 231.324 217 229.328C217.014 227.359 215.824 226.033 213.391 226.02H210.492V232.691ZM227.801 222.656V242.453H223.754V222.656H227.801ZM237.672 242.754C233.119 242.74 230.33 239.801 230.344 235.098C230.33 230.518 233.16 227.414 237.508 227.414C241.404 227.414 244.48 229.875 244.48 234.934V236.082H234.336C234.336 238.324 235.662 239.705 237.754 239.719C239.135 239.705 240.119 239.104 240.516 238.215H244.371C243.797 240.963 241.336 242.74 237.672 242.754ZM234.336 233.539H240.652C240.639 231.734 239.395 230.436 237.59 230.449C235.73 230.436 234.418 231.83 234.336 233.539Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.543 150.634L143.668 108.467L255.481 170.059L167.357 212.226L55.543 150.634Z",
    fill: "#222D49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.152 52.1543V52.647C140.152 52.647 143.583 55.2623 144.976 56.769L145.563 56.6837V56.2573L140.152 52.1543Z",
    fill: "#1A2843"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.852 59.863V60.64C129.852 60.64 142.843 61.0001 149.315 66.9509V65.7664C149.315 65.7664 143.582 60.1473 129.852 59.8535V59.863Z",
    fill: "#121D31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.151 52.1524C155.066 51.7071 163.272 58.9939 163.272 58.9939L149.286 65.7786C142.482 60.0742 129.842 59.8657 129.842 59.8657C129.842 59.8657 135.887 56.5871 145.183 56.3881C145.183 56.3881 144.074 55.3079 142.814 54.256C142.16 53.7159 140.151 52.1524 140.151 52.1524Z",
    fill: "#283D6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.834 87.1465L290.543 149.213V153.003L176.834 90.463V87.1465Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.542 111.31V107.52L178.728 45.9277L174.938 47.8229L290.542 111.31Z",
    fill: "#283B68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6035 133.579L178.728 91.4121L290.542 153.005L202.417 195.172L90.6035 133.579Z",
    fill: "#4966A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6035 129.79L178.728 87.623L290.542 149.215L202.417 191.856L90.6035 129.79Z",
    fill: "#233457"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6035 91.882L178.728 49.7148L290.542 111.307L202.417 153.474L90.6035 91.882Z",
    fill: "#3B548D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6035 88.0949L178.728 45.9277L290.542 107.52L202.417 149.687L90.6035 88.0949Z",
    fill: "#5C7CC5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6035 88.0949L178.728 45.9277L290.542 107.52L202.417 149.687L90.6035 88.0949Z",
    fill: "url(#paint0_linear_500_11555)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6035 88.0938V134.051L202.417 195.644V149.686L90.6035 88.0938Z",
    fill: "#243969"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6035 88.0938V134.051L202.417 195.644V149.686L90.6035 88.0938Z",
    fill: "url(#paint1_linear_500_11555)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.594 149.687V111.311L202.891 152.056V191.854L289.594 149.687Z",
    fill: "#E1E8FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M289.594 149.687V111.311L202.891 152.056V191.854L289.594 149.687Z",
    fill: "url(#paint2_linear_500_11555)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.543 107.523V111.314L204.787 152.344V190.711L290.543 149.217V153.007L202.418 195.648V149.691L290.543 107.523Z",
    fill: "#2C4071"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_500_11555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 61,
    width: 77,
    height: 45
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.459 105.057L128.082 92.3881L181.298 61.6582L204.675 74.3273L151.459 105.057Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_500_11555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.299 94.3591C145.214 94.4065 145.138 94.4539 145.043 94.5012L142.437 95.8373L135.88 91.9807L138.476 90.6446C140.675 89.5265 143.044 89.7444 144.967 90.891C146.863 91.9902 147.194 93.2694 145.299 94.3686M128.896 91.9333L148.369 103.39L152.046 101.494L145.697 97.7609L148.881 96.1216C149.042 96.0363 149.203 95.951 149.355 95.8657C152.946 93.7906 152.501 91.1279 148.767 88.939C144.929 86.6837 139.888 86.2668 135.861 88.3515L128.906 91.9333",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.849 92.2562C159.816 92.8532 159.93 93.8766 161.142 94.5588C162.365 95.3074 164.307 95.4211 165.463 94.8241C165.492 94.8052 165.52 94.7957 165.549 94.7768C166.544 94.2082 166.449 93.1659 165.236 92.4457C163.995 91.7161 162.043 91.6119 160.962 92.1804C160.915 92.1994 160.877 92.2278 160.839 92.2467",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.187 83.0773C167.102 83.1246 167.017 83.172 166.922 83.2194L164.325 84.5555L157.759 80.6894L160.355 79.3533C162.553 78.2351 164.922 78.4531 166.846 79.5997C168.741 80.6988 169.082 81.9781 167.187 83.0678M150.775 80.6325L170.248 92.0982L173.924 90.203L167.576 86.4696L170.759 84.8303C170.921 84.745 171.072 84.6597 171.214 84.5839C174.815 82.5087 174.37 79.846 170.636 77.6476C166.799 75.3924 161.758 74.9755 157.721 77.0507L150.766 80.6325",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.336 72.6226L185.818 84.0883L189.438 82.2215L169.965 70.7559L166.336 72.6226Z",
    fill: "#FC7B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.186 71.1161L186.529 74.0346C184.984 73.0491 184.738 71.7036 186.225 70.8413C186.282 70.8034 186.349 70.775 186.415 70.7371C188.016 69.8937 190.404 70.0737 192.195 71.1066M182.975 69.2209C179.488 71.2298 180.123 74.2147 184.491 76.7731C189.106 79.5021 194.498 79.9191 198.591 77.8249C198.733 77.7491 198.876 77.6733 199.008 77.5975C201.889 75.9298 202.22 73.883 200.126 72.1016L196.677 73.883C197.17 74.5463 196.924 75.3138 195.834 75.9487C195.786 75.9771 195.739 76.0056 195.682 76.034C193.797 76.9911 191.248 76.8015 189.04 75.5034L198.127 70.8223L196.99 70.159C192.015 67.231 186.832 67.2215 183.345 69.0219C183.212 69.0883 183.089 69.1546 182.966 69.2304",
    fill: "#FC7B72"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_500_11555",
    x1: 133.01,
    y1: 76.6024,
    x2: 229.193,
    y2: 93.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7CC5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_500_11555",
    x1: 90.897,
    y1: 88.5588,
    x2: 137.169,
    y2: 141.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E3265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979729,
    stopColor: "#222D49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_500_11555",
    x1: 216.714,
    y1: 140.031,
    x2: 249.988,
    y2: 170.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLibrary01);
export default __webpack_public_path__ + "static/media/mini_library_01.ce3d9f020631b0c1fa3207433bdcf9b0.svg";
export { ForwardRef as ReactComponent };